import {
  GoalsIcon,
  ImplementationIcon,
  PurposeIcon,
} from 'secondstep-components'
import GoalsModal from 'components/GoalsModal'
import ImplementationApproachModal from 'components/ImplementationApproachModal'
import InformFamilyModal from 'components/InformFamilyModal'
import KickoffModal from 'components/KickoffModal'
import PurposeModal from 'components/PurposeModal'
import SummaryModal from 'components/SummaryModal'
import {
  ALL_STAFF_BUTTON_TEXT,
  FAMILIES_BUTTON_TEXT,
  GOALS_TEXT,
  IMPLEMENTATION_APPROACH_TEXT,
  PURPOSE_TEXT,
  SUMMARY_LINK_TEXT,
} from './constants'

export const goalNavigationData = [
  {
    key: 'goal 1',
    label: 'Classes',
    isOptional: false,
    isCompletedProp: 'goal1IsCompleted',
  },
  {
    key: 'goal 2',
    label: 'Lessons',
    isOptional: false,
    isCompletedProp: 'goal2IsCompleted',
  },
  {
    key: 'goal 3',
    label: 'Goal 3',
    isOptional: true,
    isCompletedProp: 'goal3IsCompleted',
  },
  {
    key: 'goal 4',
    label: 'Goal 4',
    isOptional: true,
    isCompletedProp: 'goal4IsCompleted',
  },
  {
    key: 'goal 5',
    label: 'Goal 5',
    isOptional: true,
    isCompletedProp: 'goal5IsCompleted',
  },
]

export const modalMap = {
  [ALL_STAFF_BUTTON_TEXT]: {
    component: KickoffModal,
  },
  [FAMILIES_BUTTON_TEXT]: {
    component: InformFamilyModal,
  },
  [GOALS_TEXT]: {
    component: GoalsModal,
  },
  [IMPLEMENTATION_APPROACH_TEXT]: {
    component: ImplementationApproachModal,
  },
  [PURPOSE_TEXT]: {
    component: PurposeModal,
  },
  [SUMMARY_LINK_TEXT]: {
    component: SummaryModal,
  },
}

export const stepDataMap = {
  0: {
    estimatedTime: '2 min.',
    Icon: ImplementationIcon,
    label: IMPLEMENTATION_APPROACH_TEXT,
    modalName: IMPLEMENTATION_APPROACH_TEXT,
    number: 1,
    title: 'Choose Your Implementation Approach',
  },
  1: {
    estimatedTime: '5 min.',
    Icon: GoalsIcon,
    label: GOALS_TEXT,
    modalName: GOALS_TEXT,
    number: 2,
    title: 'Add Goals for Your School',
  },
  2: {
    estimatedTime: '5 min.',
    Icon: PurposeIcon,
    label: PURPOSE_TEXT,
    modalName: PURPOSE_TEXT,
    number: 3,
    title: 'Add Your Purpose Statement',
  },
}

export const fieldNames = [
  'ClassCreationGoalDate',
  'ClassCreationGoalValue',
  'CounselorLed',
  'FamilyLetterSent',
  'Goal3Text',
  'Goal4Text',
  'Goal5Text',
  'Goal5Date',
  'ImplementationType',
  'KickoffHosted',
  'KickoffPrepared',
  'LessonCompletionGoalDate',
  'LessonCompletionGoalValue',
  'ProgramIsEnabled',
  'ProgramStartDate',
  'Purpose',
  'TeacherLed',
  'UserInvitationMethod',
]
